import React from 'react'

const Loader = (props) => {
  const height = props.height ?? `50vh`
  return (
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: height}}>
        <div>
            <img src="/images/loading-animation.gif" alt="Loading..." loading='lazy' />
        </div>
    </div>
  )
}

export default Loader;